import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import api from '../../services/api'

export default function LoginSuperAdmin() {
  const { loginSuperAdmin } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState('')
  const [showPass, setShowPass] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setError(''); setCargando(true)
    try {
      const { data } = await api.post('/auth/superadmin/login', form)
      loginSuperAdmin(data)
      navigate('/admin/dashboard')
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales incorrectas')
    } finally {
      setCargando(false)
    }
  }

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: "'Inter', sans-serif" }}>

      {/* ── Panel izquierdo ── */}
      <div className="login-left" style={{
        padding: '48px 56px',
        background: 'linear-gradient(145deg, #020617 0%, #0c1220 25%, #111827 55%, #1e293b 80%, #0f172a 100%)',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Decoración */}
        <div style={{ position: 'absolute', top: -80, right: -80, width: 320, height: 320, borderRadius: '50%', background: 'rgba(245,158,11,0.06)' }} />
        <div style={{ position: 'absolute', bottom: -60, left: -60, width: 260, height: 260, borderRadius: '50%', background: 'rgba(245,158,11,0.04)' }} />
        <div style={{ position: 'absolute', top: '35%', right: -40, width: 160, height: 160, borderRadius: '50%', background: 'rgba(99,102,241,0.08)' }} />

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 340 }}>
          {/* Logo */}
          <div style={{
            width: 64, height: 64, borderRadius: 18,
            background: 'linear-gradient(135deg, #f59e0b, #d97706)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 30, margin: '0 auto 20px',
            boxShadow: '0 8px 32px rgba(245,158,11,0.35)',
          }}>
            👑
          </div>

          <h2 style={{ fontSize: 26, fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 12 }}>
            Panel Super Admin
          </h2>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, marginBottom: 40 }}>
            Acceso restringido al administrador del SaaS. Solo personal autorizado.
          </p>

          {/* Info cards */}
          {[
            { icon: '🏢', text: 'Gestión de empresas y clientes' },
            { icon: '💰', text: 'Control de planes y facturación' },
            { icon: '🔒', text: 'Acceso con privilegios máximos' },
          ].map((f, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: '11px 16px',
              marginBottom: 10, textAlign: 'left',
              border: '1px solid rgba(255,255,255,0.08)',
            }}>
              <span style={{ fontSize: 18 }}>{f.icon}</span>
              <span style={{ fontSize: 13, fontWeight: 500, color: 'rgba(255,255,255,0.75)' }}>{f.text}</span>
            </div>
          ))}
        </div>

        <div style={{ position: 'absolute', bottom: 28, fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>
          MixCRM · Acceso administrativo
        </div>
      </div>

      {/* ── Panel derecho ── */}
      <div className="login-right" style={{ background: '#fafafa' }}>
        <div className="login-form-wrap" style={{ width: '100%', maxWidth: 400, animation: 'fadeInUp 0.4s ease' }}>
          {/* Cabecera mobile */}
          <div className="login-mobile-brand" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
            <span style={{ fontSize: 28 }}>👑</span>
            <span>Super Admin</span>
          </div>
          <div style={{ marginBottom: 32 }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)',
              color: '#d97706', padding: '4px 12px', borderRadius: 20,
              fontSize: 12, fontWeight: 600, marginBottom: 16,
            }}>
              🔒 Zona restringida
            </div>
            <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', marginBottom: 8 }}>
              Iniciar sesión
            </h2>
            <p style={{ fontSize: 14, color: '#6b7280' }}>
              Ingresa tus credenciales de super administrador
            </p>
          </div>

          <form onSubmit={submit}>
            <div style={{ marginBottom: 18 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Correo electrónico
              </label>
              <input
                className="input"
                type="email"
                required
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                placeholder="admin@mixcrm.click"
                style={{ fontSize: 15, padding: '11px 14px' }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Contraseña
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  className="input"
                  type={showPass ? 'text' : 'password'}
                  required
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  style={{ fontSize: 15, padding: '11px 44px 11px 14px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(s => !s)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 17, color: '#9ca3af' }}
                >
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={cargando}
              style={{
                width: '100%', padding: '13px 20px', fontSize: 15, fontWeight: 600,
                border: 'none', borderRadius: 10, cursor: 'pointer', marginBottom: 12,
                background: cargando ? '#9ca3af' : 'linear-gradient(135deg, #f59e0b, #d97706)',
                color: 'white', boxShadow: '0 4px 16px rgba(245,158,11,0.35)',
                transition: 'all 0.2s',
              }}
            >
              {cargando
                ? <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                    <span className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} />
                    Verificando...
                  </span>
                : 'Acceder al panel →'}
            </button>

            {error && (
              <div style={{ color: '#dc2626', fontSize: 13, textAlign: 'center', padding: '10px 14px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' }}>
                {error}
              </div>
            )}
          </form>

          <p style={{ textAlign: 'center', marginTop: 28, fontSize: 12, color: '#9ca3af' }}>
            <a href="/login" style={{ color: '#9ca3af', textDecoration: 'none' }}>
              ← Volver al login de empresa
            </a>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
